import {
  DEFAULT_OG_IMAGE,
  SITE_NAME,
  SITE_URL,
  type SeoConfig,
} from './site'

export type SeoHelmetTags = {
  title: string
  description: string
  canonical: string
  index: boolean
  ogType: string
}

export function seoToHelmet({
  title,
  description,
  path,
  index = true,
  ogType = 'website',
}: SeoConfig): SeoHelmetTags {
  const canonical = `${SITE_URL}${path === '/' ? '' : path}`
  return {
    title,
    description,
    canonical,
    index,
    ogType,
  }
}

/** @deprecated Use seoToHelmet - kept for any legacy imports */
export const seoToMetadata = seoToHelmet

export { DEFAULT_OG_IMAGE, SITE_NAME, SITE_URL }
